import { Button } from "@risalabs_frontend_org/oasis-ui-kit";
import { ReactNode } from "react";

/** Props for {@link OrderBlocked}. */
export interface OrderBlockedProps {
  /** Icon shown above the heading. */
  icon: ReactNode;
  /** Primary heading text. */
  header: string;
  /** Supporting description below the heading. */
  subheader: string;
  /** Primary action button label. */
  buttonText: string;
  /** Primary action button click handler. */
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Full-page blocked-order state shown when an order cannot be opened yet.
 *
 * @param props.icon - Icon shown above the heading
 * @param props.header - Primary heading text
 * @param props.subheader - Supporting description below the heading
 * @param props.buttonText - Primary action button label
 * @param props.onClick - Primary action button click handler
 * @returns Centered blocked-order panel
 */
const OrderBlocked = ({
  icon,
  header,
  subheader,
  buttonText,
  onClick,
}: OrderBlockedProps) => {
  return (
    <div className="order-blocked--container flex h-full w-full flex-col items-center justify-center gap-2">
      <div className="icon">{icon}</div>
      <div className="header text-h10 font-bold text-primaryGray-1">
        {header}
      </div>
      <div className="sub-header w-72 text-center text-sm font-medium text-primaryGray-4">
        {subheader}
      </div>
      <div className="action mt-4">
        <Button
          disabled={false}
          buttonType="primary"
          size="medium"
          className="w-full"
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default OrderBlocked;
